module.exports = __webpack_public_path__ + "static/media/礼包.8457477f.jpg";